module.exports = __webpack_public_path__ + "static/media/Cricket-banner.ff2d3f6d.jpg";